<template>
  <div class="dashboard">
    <div class="dashboard-overview" v-if="!feeds.length">
      <div class="dashboard-gettingStarted">
        <img class="dashboard-leftArrow" src="./../assets/left-arrow.svg">
        Click on "Add New Feed" to get started
      </div>
    </div>
    <div
      class="dashboard-feeds"
      v-for="(feedGroup, feedGroupIndex) in feeds"
      v-if="feedGroupIndex === currentFeed"
    >
      <template v-if="feedGroup">
        <dashboardheader-com
          v-if="!Array.isArray(feedGroup[0])"
          :feedGroup="feedGroup[0]"
          :feedGroupIndex="feedGroupIndex"
        ></dashboardheader-com>
        <div
          class="feedGroup"
          :class="{'bm-first': feedIndex === 1, 'bm-last': feedIndex === feedGroup.length - 1}"
          v-for="(feed, feedIndex) in feedGroup"
          v-if="Array.isArray(feed)"
        >
          <div class="feedGroup-area"></div>
          <div class="feedGroup-sort">
            <div class="feedGroup-sortUp" @click="moveUp(feedIndex)">
              <icon-com
                name="arrow-up"
                size="small"
              ></icon-com>
            </div>
            <div class="feedGroup-sortDown" @click="moveDown(feedIndex)">
              <icon-com
                name="arrow-down"
                size="small"
              ></icon-com>
            </div>
          </div>
          <div
            class="feedGroup-feed"
            :class="{'m-header' : input.name === 'name'}"
            v-for="(input, inputIndex) in feed"
            v-if="Array.isArray(feed) && feed[0].visible || input.name === 'name'"
          >
            <feedgroupheader-com
              :feedGroupIndex="feedGroupIndex"
              :feedIndex="feedIndex"
              v-if="input.name === 'name'"
            ></feedgroupheader-com>
            <component
              :feedGroupIndex="feedGroupIndex"
              :feedIndex="feedIndex"
              :inputIndex="inputIndex"
              :name="input.name"
              :value="input.value"
              :is="input.type + '-input'"
              v-if="input.type !== 'name'"
            ></component>
          </div>
        </div>
        <dashboardfooter-com
          :feedId="feedGroup[0].id"
        ></dashboardfooter-com>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import TextInput from '@/inputs/Text'
import NumberInput from '@/inputs/Number'
import ListInput from '@/inputs/List'
import HtmlInput from '@/inputs/Html'
import ImageInput from '@/inputs/Image'

import FeedgroupheaderCom from '@/components/FeedGroupHeader'
import DashboardfooterCom from '@/components/DashboardFooter'
import DashboardheaderCom from '@/components/DashboardHeader'

export default {
  components: {
    TextInput,
    NumberInput,
    ListInput,
    HtmlInput,
    ImageInput,
    FeedgroupheaderCom,
    DashboardheaderCom,
    DashboardfooterCom
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },
    feeds () {
      return this.$store.state.feeds
    },
    currentFeed () {
      return this.$store.state.currentFeed
    }
  },
  mounted () {
    this.setValue()
  },
  data () {
    return {
      oldFeeds: []
    }
  },
  methods: {
    setValue () {
      this.oldFeeds = _.cloneDeep(this.feeds)
    },
    moveUp (feedIndex) {
      this.$store.commit({
        type: 'moveTo',
        feedGroupIndex: this.currentFeed,
        oldIndex: feedIndex,
        newIndex: feedIndex - 1
      })
    },
    moveDown (feedIndex) {
      this.$store.commit({
        type: 'moveTo',
        feedGroupIndex: this.currentFeed,
        oldIndex: feedIndex,
        newIndex: feedIndex + 1
      })
    }
  },
  watch: {
    feeds: {
      handler () {
        let preventChange = false

        this.feeds.forEach((row, rowIndex) => {
          if (row.length !== this.oldFeeds[rowIndex].length) {
            return
          }

          row.forEach((fields, fieldIndex) => {
            if (fieldIndex === 0) {
              return
            }

            const after = fields[0].visible || false
            const oldRow = this.oldFeeds[rowIndex]

            if (!oldRow[fieldIndex]) {
              return
            }

            const before = oldRow[fieldIndex][0].visible || false

            if (!preventChange) {
              preventChange = after !== before
            }
          })
        })

        if (this.feeds.length < this.oldFeeds.length) {
          return
        }

        this.setValue()

        if (preventChange) {
          preventChange = false
          return
        }

        this.$store.commit('changesFound', true)

        preventChange = false
      },
      deep: true
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('dashboard')
  width: 100%
  height: 100%

  +element('feeds')
    padding-bottom: 200px

  +element('overview')
    display: flex
    justify-content: center
    align-items: center
    height: 100%

  +element('gettingStarted')
    font-size: 18px
    padding-top: 100px
    position: relative

  +element('leftArrow')
    position: absolute
    left: 50%
    transform: translateX(calc(-50% - 150px))
    top: -30px
    width: 120px


+block('feedGroup')
  background: #FFFFFF
  box-shadow: inset 0 0 0 1px rgba(0,0,0,.1), 0 2px 4px 0 rgba(0,0,0,0.05)
  max-width: 474px
  margin: 0 auto 25px
  border-radius: 35px
  position: relative

  &:hover .feedGroup-sortDown, &:hover .feedGroup-sortUp
    opacity: 1
    pointer-events: auto

  +element('sort')
    height: 56px
    width: 24px
    position: absolute
    right: -34px
    top: 7px

  +element('sortUp')
    width: 24px
    height: 24px
    position: absolute
    cursor: pointer
    border-radius: 3px
    background-color: #FFF
    box-shadow: inset 0 0 0 1px rgba(0,0,0,.1), 0 2px 4px rgba(0,0,0,.15)
    opacity: 0
    transition: opacity .15s, transform .3s
    transform: scale(1) translateZ(0)

    &:active
      transform: scale(.95) translateZ(0)

    +blockModifier('first')
      display: none

    +blockModifier('last')
      top: 50%
      margin-top: -12px

  +element('sortDown')
    width: 24px
    height: 24px
    position: absolute
    bottom: 0
    cursor: pointer
    border-radius: 3px
    background-color: #FFF
    box-shadow: inset 0 0 0 1px rgba(0,0,0,.1), 0 2px 4px rgba(0,0,0,.15)
    opacity: 0
    transition: opacity .15s, transform .3s
    transform: scale(1) translateZ(0)

    &:active
      transform: scale(.95) translateZ(0)

    +blockModifier('last')
      display: none

    +blockModifier('first')
      top: 50%
      margin-top: -12px

  +element('area')
    width: calc(100% + 40px)
    height: 100%
    position: absolute

  +element('feed')
    width: 100%
    border-top: 2px solid $divider
    box-sizing: border-box
    padding: 25px 25px 35px
    position: relative

    +modifier('header')
      padding: 0
      border-top: none

</style>



// WEBPACK FOOTER //
// src/routerViews/Dashboard.vue